import { render, staticRenderFns } from "./AppElementsList.vue?vue&type=template&id=604ca0c1&scoped=true"
import script from "./AppElementsList.vue?vue&type=script&lang=js"
export * from "./AppElementsList.vue?vue&type=script&lang=js"
import style0 from "./AppElementsList.vue?vue&type=style&index=0&id=604ca0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ca0c1",
  null
  
)

export default component.exports